import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import BasicNav from "./BasicNav";
import HorizontalNav from "./HorizontalNav";
import VerticalNav from "./VerticalNav";
import NoNav from './NoNav';
import { useSettings } from '../context/SettingsContext';
const NavigationWrapper = ({ children }) => {
    const { navigationMode, } = useSettings();
    return (_jsxs(_Fragment, { children: [navigationMode == "none" && (_jsx(NoNav, { children: children })), navigationMode == 'basic' && (_jsx(BasicNav, { children: children })), navigationMode == 'verticalStepper' && (_jsx(VerticalNav, { children: children })), navigationMode == 'horizontalStepper' && (_jsx(HorizontalNav, { children: children }))] }));
};
export default NavigationWrapper;
